var map = {
	"./de_DE.json": 1222,
	"./en_AU.json": 1223,
	"./en_CA.json": 1224,
	"./en_GB.json": 1225,
	"./es_AR.json": 1226,
	"./es_ES.json": 1227,
	"./es_MX.json": 1228,
	"./fr_CA.json": 1229,
	"./fr_FR.json": 1230,
	"./it_IT.json": 1231,
	"./nl_NL.json": 1232,
	"./pt_BR.json": 1233,
	"./pt_PT.json": 1234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1221;